// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timer {\n  width: 100px;\n  max-width: 200px;\n  padding: 0px;\n  margin-right: 15px;\n  font-size: 18px;\n  font-weight: 600;\n  text-align: center;\n  vertical-align: middle;\n}\n.jira-link {\n  text-decoration: none;\n}\n.jira-link:hover, .jira-link:focus {\n  text-decoration: underline;\n}\n.v-picker__title.primary {\n  display: none;\n}\n.inline-edit-form {\n  max-width: 250px !important;\n}", ""]);
// Exports
module.exports = exports;
